import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { MoneyTransaction } from '@zero/shared/util-models';

export const moneyTransactionsActions = createActionGroup({
  source: 'Money Transactions',
  events: {
    'Load Money Transactions': props<{ force: boolean }>(),
    'Increment Money Transactions Page': emptyProps(),
    'Reset Money Transactions': emptyProps(),
  },
});

export const moneyTransactionsApiActions = createActionGroup({
  source: 'Money Transactions API',
  events: {
    'Load Money Transactions From Api': emptyProps(),
    'Load Money Transactions Success': props<{ moneyTransactions: MoneyTransaction[]; hasNext: boolean }>(),
    'Load Money Transactions Failure': props<{ error: HttpErrorResponse }>(),
  },
});
